import { render } from "./lngbbd.vue?vue&type=template&id=5d413396&scoped=true&ts=true"
import script from "./lngbbd.vue?vue&type=script&lang=ts"
export * from "./lngbbd.vue?vue&type=script&lang=ts"

import "./lngbbd.vue?vue&type=style&index=0&id=5d413396&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d413396"]])

export default __exports__